

















import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';

@Component
export default class TopBar extends Vue {
  private get isOutOfMain(): boolean {
    return this.$route.name !== 'Main';
  }

  handleBack(): Promise<Route> | void {
    switch (this.$route.name) {
      case 'Search':
        return this.$router.push({ path: '/' });

      default:
        return this.$router.back();
    }
  }
}
